import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, OnInit, OnDestroy, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { switchMap, takeUntil } from 'rxjs/operators';
import * as toastr from 'toastr';
import { Subject } from 'rxjs';
import { LoginContabil } from '../../entidade/login/login-contabil';
import { GlobalService } from '../../util/global.service';
import { FuncaoService } from '../../util/funcao.service';
import { TermoAcessoService } from '../service/termo-acesso.service';
import { TermoAcesso } from '../../entidade/comum/termo-acesso.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

declare var $: any;

@Component({
  selector: 'lib-termo-acesso',
  templateUrl: './termo-acesso.component.html'
})
export class TermoAcessoComponent implements OnInit, AfterViewInit, OnDestroy {

  protected login: LoginContabil;
  protected datepipe: DatePipe;
  public ptBR: any;

  public paginaCorrente: number;
  public paginaTotal: number;
  public filtro: string;
  public visualizacao:boolean = false;
  public listAcessos: Array<TermoAcesso>;

  protected unsubscribe: Subject<void> = new Subject();

  public entidadeForm: FormGroup;
  protected activatedRoute: ActivatedRoute;
  protected fb: FormBuilder;

  limite: number = 10;

  imaskConfig = {
    mask: Number,
    scale: 2,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };

  constructor(
    protected injector: Injector,
    private route: ActivatedRoute,
    protected messageService: MessageService,
    public globalService: GlobalService,
    private termoAcessoService: TermoAcessoService,
    private confirmationService: ConfirmationService,
  ) { }

  ngOnInit() {
    this.fb = this.injector.get(FormBuilder);
    this.login = GlobalService.obterSessaoLogin();
    this.paginaCorrente = 1;
    this.ptBR = this.globalService.obterDataBR();
    this.datepipe = new DatePipe('pt');
    this.criarCamposForm();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  ngAfterViewInit() {
    this.globalService.calendarMascara();
    this.preencherGrid();
  }

  public async submitForm() {
    if (this.entidadeForm.invalid) {
      toastr.error('Há campos obrigatórios não informados!');
      return;
    }

    this.confirmationService.confirm({
      header: 'Confirmar Alteração do Termo em Vigência',
      message: 'Ao salvar um novo termo de usuário, o último termo será revogado e este passará a ser o termo em exercício!',
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Confirmar",
      rejectLabel: "Cancelar",
      accept: () => {
        this.criarEntidade();
      },
      reject: () => {
      },
    });
  }

  private criarEntidade() {
    const entidade: TermoAcesso = TermoAcesso.converteJson(this.entidadeForm.value);
    this.termoAcessoService
      .inserir(entidade)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(res => {
        this.acaoSucesso();
      },
        error => this.acaoErro(error));
  }

  private acaoErro(error: any) {
    toastr.options.timeOut = 10000;
    toastr.options.closeButton = true;
    toastr.options.tapToDismiss = false;
    if (error.error && error.error.payload) {
      toastr.error(error.error.payload);
    } else {
      toastr.error('Ocorreu um erro ao processar a sua solicitação');
    }
  }

  private acaoSucesso() {
    toastr.success('Registro salvo com sucesso!');
    this.preencherGrid();
    $('#dialogCadastroTermo').modal('hide');
    this.criarCamposForm();
  }

  public revogar(item: TermoAcesso) {
    this.confirmationService.confirm({
      header: 'Confirmar Revogação do Termo',
      message: 'Ao revogar este termo, todos os termos vinculados aos usuários também serão revogados. Deseja continuar?',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Confirmar',
      rejectLabel: 'Cancelar',
      accept: () => {
        const entidade = TermoAcesso.converteJson(item);
        entidade.revogado = true;

        this.termoAcessoService
          .atualizar(entidade)
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(
            () => {
              toastr.success('Termo revogado com sucesso!');
              this.preencherGrid();
            },
            error => this.acaoErro(error)
          );
      },
      reject: () => {
      },
    });
  }

  public visualizar(item: TermoAcesso) {
    this.visualizacao = true;
    this.entidadeForm = this.fb.group({
      id: [null],
      revogado: [false],
      modelo: [item.modelo, [Validators.required]],
      descricao: [item.descricao, [Validators.required]],
    });
  }

  
  public inserir() {
    this.visualizacao = false;
    this.entidadeForm = this.fb.group({
      id: [null],
      revogado: [false],
      modelo: [null, [Validators.required]],
      descricao: [null, [Validators.required]],
    });
  }

  private criarCamposForm(): void {
    this.entidadeForm = this.fb.group({
      id: [null],
      revogado: [false],
      modelo: [null, [Validators.required]],
      descricao: [null, [Validators.required]],
    });
  }


  preencherGrid() {
    const parametros = [];
    if (this.filtro) {
      const filtroSemAcentos = new FuncaoService().removerAcentos(this.filtro);
      parametros['descricao$like'] ='%'.concat(filtroSemAcentos.concat('%'));
    }

    parametros['orderBy'] = 'data_cadastro$DESC';
    this.termoAcessoService.filtrar(
      this.paginaCorrente, this.limite, parametros
    ).pipe(takeUntil(this.unsubscribe)).subscribe(
      lista => {
        this.listAcessos = lista.content;
        this.paginaTotal = lista.totalPages;
      }, error => {
        if (error.error && error.error.payload) {
          toastr.error(error.error.payload);
        } else {
          toastr.error('Ocorreu um erro ao processar a sua solicitação');
        }
      });
  }

  public onClick() {
    this.preencherGrid();
  }

  public onKeydown(event: any) {
    if (event.key === 'Enter') {
      document.getElementById('button-addon2').click();
    }
  }

  public proximaPagina() {
    this.paginaCorrente = this.paginaCorrente === this.paginaTotal ? this.paginaTotal : this.paginaCorrente + 1;
    this.preencherGrid();
    window.scrollTo(0, 0);
  }

  public paginaDigitada(pagina: number) {
    this.paginaCorrente =
      +pagina >= this.paginaTotal
        ? this.paginaTotal
        : +pagina;
    this.preencherGrid();
    window.scrollTo(0, 0);
  }

  public paginaAnterior() {
    this.paginaCorrente = this.paginaCorrente === 1 ? 1 : this.paginaCorrente - 1;
    this.preencherGrid();
    window.scrollTo(0, 0);
  }

  public mudarLimite(limite: number) {
    this.limite = limite;
    this.paginaDigitada(1);
  }
}
